function buildOrigin(value: string, label: string): string {
  const url = new URL(value)
  if (url.protocol !== 'https:' || url.username || url.password || url.origin !== value) throw new Error(`${label} 构建配置无效`)
  return url.origin
}

export const audienceEnvironment = Object.freeze({
  name: __AUDIENCE_ENVIRONMENT__,
  cdnBase: buildOrigin(__AUDIENCE_CDN_BASE__, 'CDN'),
  apiBase: buildOrigin(__AUDIENCE_API_BASE__, 'API'),
  showDemoSkinSwitcher: __SHOW_DEMO_SKIN_SWITCHER__,
})

export function audienceManifestUrl(stadiumId: string): string {
  return `${audienceEnvironment.cdnBase}/config/${encodeURIComponent(stadiumId)}/audience/manifest.json`
}

export function isAudienceCdnUrl(value: string): boolean {
  try { return new URL(value).origin === audienceEnvironment.cdnBase } catch { return false }
}
